import {
    get,
    isEqual
} from 'lodash';
import { createSelector } from 'reselect';
import { getEntityByName } from '../appEntities';
import {
    APMS_FAILURE,
    APMS_LOAD,
    APMS_SUCCESS
} from './apmActions';

export default function reducer(state = { apms: [] }, action = {}) {
    let newState;

    switch (action.type) {
        case APMS_LOAD:
            newState = {
                ...state,
                error: null,
                isLoaded: false,
                isLoading: true,
                apms: []
            };

            return isEqual(state, newState) ? state : newState;

        case APMS_SUCCESS:
            newState = {
                ...state,
                isLoaded: true,
                isLoading: false,
                apms: action.apms
            };

            return isEqual(state, newState) ? state : newState;

        case APMS_FAILURE:
            newState = {
                ...state,
                error: action.error,
                isLoading: false,
                apms: []
            };

            return isEqual(state, newState) ? state : newState;

        default:
            return state;
    }
}

export const getApmsEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'apms')
);

export const getIsApmsLoaded = createSelector(
    getApmsEntity,
    (entity) => get(entity, 'isLoaded')
);

export const getIsApmsLoading = createSelector(
    getApmsEntity,
    (entity) => get(entity, 'isLoading')
);

export const getApms = createSelector(
    getApmsEntity,
    (entity) => {
        return get(entity, 'apms');
    }
);

